import React, { useState } from 'react'
import { Button, Grid, Card, Paper } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import ModalAbm from '../../compartidos/abms/ModalAbm';
import { MedicosAbm } from './MedicosAbmStepper/Forms/MedicosAbm';
import { useDispatch, useSelector } from 'react-redux';
import { MedicosModif } from './MedicosAbmStepper/Forms/MedicosModif';
import { useEffect } from 'react';
import { abmMedicosLimpiar, desSeleccionarAbmMedicos, seleccionAbmMedicos } from '../../../actions/medicosabm/medicosAbm';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import { USUARIOS_PERMISOS } from '../../../utils/permisos';
import Buscador from '../../../actions/ui/Buscador';

const useStyles = makeStyles({
  botonera: {
    padding: 25
  },
  buscador: {
    padding: 10
  }
});
export const MedicosAbmScreenNew = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openAlta, setOpenAlta] = useState(false);
  const [Medicos, setMedicos] = useState(false);
  const [showMedicosModif, setShowMedicosModif] = useState(false); // Estado para controlar la visibilidad de MedicosModif
  const { consultaMedico } = useSelector((state) => state.medico);
  const { permisos: permisosUser } = useSelector(state => state.auth)


  const cerrarModalAlta = () => { setOpenAlta(false) }

  const cerrarModalModif = () => { setShowMedicosModif(false); dispatch(abmMedicosLimpiar()); }


  useEffect(() => {
    dispatch(abmMedicosLimpiar())
  }, []);

  useEffect(() => {
    if (consultaMedico?.idEfectorRed > 0) {
      setShowMedicosModif(true);
      setMedicos(consultaMedico);
    } else {
      setShowMedicosModif(false);
      dispatch(abmMedicosLimpiar());
    }
  }, [consultaMedico]);

  return (
    <div>
      <Grid container justify="center">
        <ModalAbm title="Agregar Medico" open={openAlta} setOpen={setOpenAlta}>
          <MedicosAbm Medicos={null} cerrarModal={cerrarModalAlta} />
        </ModalAbm>
        <Grid item xs={12}>
          {validarSoloUnPermiso(permisosUser, USUARIOS_PERMISOS.ALTA) && (
            <Button variant="contained" color="primary" onClick={() => { setOpenAlta(true); setShowMedicosModif(false) }} style={{ float: "right", marginTop: "1rem" }}>+ Agregar Medico</Button>
          )}
        </Grid>
        <Grid item xs={12} md={6} className={classes.buscador} component={Paper}>
          <Buscador
            value={consultaMedico}
            variant="outlined"
            setValue={(medico) => {
              if (medico?.idEfectorRed) {
                dispatch(seleccionAbmMedicos(medico));
              } else {
                dispatch(desSeleccionarAbmMedicos())
              }
            }}
            label="Nombre de Fantasía | CUIT"
            endpoint={(texto) => `EfectorP/traerPorNombre/${texto}`}
            noOptionText={"No se encuentra medico"}
            getOptionLabel={(option) => (`${option.nombreEfector} - ${option.cuit}`)}
            renderOption={(option) => (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: 12 }}>
                  {`${option.nombreEfector} - CUIT: ${option.cuit}`}
                </span>
              </div>
            )}
          />
        </Grid>
        {showMedicosModif && (
          <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
            <Card>
              <MedicosModif cerrarModal={cerrarModalModif} Medicos={Medicos} />
            </Card>
          </Grid>
        )}
      </Grid>
    </div>
  )
}
